<template>
    <section>
        <header class="m-0 mb-6">
            <h1 class="fs-32 m-0">{{ $l10n.__('Finalisez votre abonnement') }}</h1>
        </header>
        <article class="mt-6">
            <header>
                <h2 class="m-0">{{ $l10n.__('Informations de contact') }}</h2>
            </header>
            <card background="lightgrey" class="card-contact mt-5 b-1-gray-05 flex-row br fs-3 flex-top">
                <ul class="my-0 gray-60 semibold unstyled">
                    <li class="mb-2">{{ $l10n.__('Prénom et Nom') }}</li>
                    <li class="mb-2">{{ $l10n.__('Email') }}</li>
                    <li>{{ $l10n.__('Téléphone') }}</li>
                </ul>
                <ul class="ml-5 my-0 unstyled">
                    <li class="mb-2 gray-100">{{ contact.forename }} {{ contact.name }}</li>
                    <li class="mb-2 gray-100">{{ contact.email }}</li>
                    <li class="gray-100">{{ contact.phone.e164 }}</li>
                </ul>
            </card>
        </article>

        <span class="separator block my-6"></span>
        <article>
            <!-- Billing Settings -->
            <h2 class="mt-0 mb-5">{{ $l10n.__('Informations de facturation') }}</h2>
            <card background="lightgrey" class="card-contact mt-5 flex-column br b-1-gray-05 fs-3 flex-top">
                <div class="info-wrapper">
                    <p class="w-200 gray-60 semibold">{{ $l10n.__('Nom de l\'entreprise') }}</p>
                    <p class="gray-100">{{ corpName }}</p>
                </div>
                <div class="info-wrapper">
                    <p class="w-200 gray-60 semibold">{{ $l10n.__('Adresse postale') }}</p>
                    <p class="flex-column gray-100">
                        <span>{{ billingSettings.line1 }}</span>
                        <span v-if="billingSettings.line2">{{ billingSettings.line2 }}</span>
                        <span v-if="billingSettings.line3">{{ billingSettings.line3 }}</span>
                        <span v-if="billingSettings.line4">{{ billingSettings.line4 }}</span>
                        <span v-if="billingSettings.state">{{ billingSettings.state }}</span>
                        <span>{{ billingSettings.postalCode }} {{ billingSettings.city }}</span>
                        <span>{{ billingSettings.country }}</span>
                    </p>
                </div>
                <div class="info-wrapper">
                    <p class="w-200 gray-60 semibold">{{ $l10n.__('Langue de facturation') }}</p>
                    <p class="gray-100">{{ billingLocale.name }}</p>
                </div>
                <div class="info-wrapper" v-if="vatIntra">
                    <p class="w-200 gray-60 semibold">{{ $l10n.__('N° TVA intracommunautaire') }}</p>
                    <p class="gray-100">{{ vatIntra }}</p>
                </div>
            </card>
        </article>

        <span class="separator block my-6"></span>
        <article>
            <header class="flex-row ai-center">
                <h2 class="my-0">{{ $l10n.__('Informations de paiement') }}</h2>
                <span v-if="isCardMethod" class="gray-60 fs-2 flex-item-right"><i class="icon-lock-fillout"></i> {{$l10n.__('Paiement sécurisé SSL')}}</span>
            </header>
            <cart-stripe-form v-if="isCardMethod" :isPublic="true"></cart-stripe-form>
            <div v-if="isManualMethod">
                <p class="gray-100"> {{ $l10n.__('Merci d’effectuer un virement du montant de votre abonnement vers le compte ci-dessous. À réception du virement nous procéderons à l’activation de votre compte.') }}</p>
                <card background="lightgrey" class="mt-3 flex-column br b-1-gray-05 fs-3 flex-top">
                    <div class="info-wrapper mb-2">
                        <p class="w-160 semibold m-0 fs-3 gray-60">{{ $filters.capitalize($l10n.__("Titulaire du compte")) }}</p>
                        <p class="m-0 fs-3 gray-100">{{ $filters.capitalize(SellsyBankInfos.accountOwner) }}</p>
                    </div>
                    <div class="info-wrapper mb-2">
                        <p class="w-160 semibold m-0 fs-3 gray-60">{{ $filters.capitalize($l10n.__("IBAN")) }}</p>
                        <p class="m-0 fs-3 gray-100">{{ $filters.capitalize(SellsyBankInfos.iban) }}</p>
                    </div>
                    <div class="info-wrapper">
                        <p class="w-160 semibold m-0 fs-3 gray-60">{{ $filters.capitalize($l10n.__("BIC (International Code)")) }}</p>
                        <p class="m-0 fs-3 gray-100">{{ $filters.capitalize(SellsyBankInfos.bic) }}</p>
                    </div>
                </card>
                <p v-html="helpEmail" class="mt-3 gray-60">
                    <!-- Need Help ? Contact abonnement@sellsy.com -->
                </p>
            </div>
        </article>
    </section>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import Card from 'vcomponents/Card.vue';
import CartStripeForm from 'vcomponents/pages/account/CartStripeForm.vue';
import SellsyBankInfos from 'Config/authenticated/sellsyBankInfos';
const clientCart = createNamespacedHelpers('clientCart');

export default {
    data() {
        return {
            contactDialog: false,
        }
    },
    computed: {
        ...clientCart.mapGetters([
            'contact',
            'billingSettings',
            'computeLoading',
            'billingLocales',
            'contact',
            'vatIntra',
            'paymentMethod',
            'isCardMethod',
            'isManualMethod',
            'vatIntra',
            'billingSettings',
            'corpName',
            'billingLocale',
        ]),
        helpEmail() {
            return this.$l10n.__('Besoin de votre abonnement Sellsy maintenant ? Envoyez-nous votre preuve d’ordre de virement à %(startLink)s abonnement@sellsy.com %(endLink)s.', {
                startLink: `<a target="_blank" class="fs-3 semibold" href="mailto:abonnement@sellsy.com?subject=${this.subjectEmail}">`,
                endLink: `</a>`
            });
        },
        SellsyBankInfos() {
            return SellsyBankInfos;
        },
        subjectEmail() {
            return this.$l10n.__('Preuve de virement pour mon abonnement Sellsy');
        }
    },
    components: {
        Card,
        CartStripeForm,
    }
}
</script>

<style lang="scss" scoped>
     @import '~@sellsy/styleguide/src/_variables';
    .info-wrapper {
        @media only  screen and (min-width : 1400px) {
            display: flex;
            flex-direction: row;

            p:last-child {
                margin-left: 8px;
            }
        }
    }
</style>